export const createTicketFiveAction = (state) => {
  return {
    type: "CREATE_TICKET_FIVE",
    payload: state,
  };
};

export const updateTicketFiveAction = (state) => {
  return {
    type: "UPDATE_TICKET_FIVE",
    payload: state,
  };
};
